import { ErrorBoundary } from '@sentry/react';
import { QueryErrorResetBoundary, type QueryKey } from '@tanstack/react-query';
import { cloneElement, type ReactElement, Suspense } from 'react';

import { RetryQueryAlert } from 'src/components/alerts/RetryQueryAlert';

type ErrorBoundarySuspenseProps = {
  loadingFallback: ReactElement;
  errorFallbackWrapper: ReactElement;
  queryKey: QueryKey;
  children: ReactElement;
  message?: string;
};

export function ErrorBoundarySuspense({
  loadingFallback,
  errorFallbackWrapper,
  queryKey,
  children,
  message,
}: ErrorBoundarySuspenseProps) {
  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary
          fallback={({ resetError }) => {
            return cloneElement(
              errorFallbackWrapper,
              {},
              <RetryQueryAlert
                isLoading={false}
                message={message}
                onRetry={resetError}
                queryKey={queryKey}
              />,
            );
          }}
          onReset={reset}
        >
          <Suspense fallback={loadingFallback}>{children}</Suspense>
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  );
}
